export default {
    RETROSPECTIVE: "R",
    PROSPECTIVE: "P",
    NO_ALLOCATION: "N",
    parse(modificationType) {
        let modType;
        if (typeof modificationType === "string") {
            modificationType = modificationType.toLowerCase();
        }
        if (modificationType == "prospective") {
            modType = this.PROSPECTIVE;
        } else if (modificationType == "no allocation") {
            modType = this.NO_ALLOCATION;
        } else if (
            modificationType == null ||
            modificationType == "" ||
            modificationType == "retrospective"
        ) {
            modType = this.RETROSPECTIVE;
        }
        return modType;
    }
};
